import React from "react";
import { ContactsOutlined } from "@ant-design/icons";
import { Descriptions, Divider, Empty } from "antd";
import { formatPhoneNumber } from "@/utils/utils";

const InfoPane = ({ parsedInfo }) => {
  if (parsedInfo === null) {
    return <Empty style={{ paddingTop: 6 }} image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }

  const { entity, user } = parsedInfo;

  return (
    <div
      style={{
        paddingTop: 16,
        paddingBottom: 16,
        paddingLeft: 24,
        paddingRight: 24,
      }}
    >
      <Descriptions
        title={entity.name}
        contentStyle={{
          marginBottom: 0,
        }}
        column={1}
      >
        <Descriptions.Item key="address" label="Address" style={{ paddingBottom: 0 }}>
          {entity.address}
        </Descriptions.Item>
        <Descriptions.Item key="phone" label="Phone" style={{ paddingBottom: 0 }}>
          {formatPhoneNumber(entity.phoneNumber, entity.phoneExtension)}
        </Descriptions.Item>
      </Descriptions>
      <Divider />
      <p>
        <ContactsOutlined /> {entity.type} Contact
      </p>
      <Descriptions title={user.fullName || "N/A"} column={1}>
        <Descriptions.Item key="email" style={{ paddingBottom: "0" }}>
          {user.email}
        </Descriptions.Item>
        <Descriptions.Item key="phone" label="Phone" style={{ paddingBottom: "0" }}>
          {formatPhoneNumber(user.phoneNumber, user.phoneExtension)}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default InfoPane;
